<template>
  <div class="trend">
    <div class="title">
     <h2>安全风险监测趋势</h2>
    </div>
    <div class="box" id="box" ref="box">
    </div>
  </div>
</template>
<script>
import {getVulnerableTrend} from "@/service/dashboard";

export default {
  data() {
    return {
      ddate:[],
      data:[65, 44, 51, 61, 27, 11, 10],
      option : {
        tooltip: {trigger: "axis"},
        grid: {
          top: "3%",
          bottom: "0%",
          left: "0%",
          right: "6%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: ["5-13", "5-14", "5-15", "5-16", "5-17", "5-18", "5-19"],
          //两边贴紧边缘
          boundaryGap: false,
          axisLine: {
            lineStyle: {color: "rgba(170, 173, 235, 1)", width: 1}
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "rgba(255, 255, 255, 1)",
            fontSize: 10,
            margin: 15
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted",
              color: "rgba(170, 173, 235, 1)"
            }
          }
        },
        yAxis: {
          type: "value",
          scale:true,
          //y轴起点不为0  当data的数据过于相近的时候
          interval: 50000,
          // max: 550000,
          // min: 0,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted",
              color: "rgba(170, 173, 235, 1)"
            }
          },
          axisLabel: {
            color: "#fff",
            fontSize: 10,
            margin: 15
          }

        },
        series: [
          {
            name: "中",
            type: "line",  //bar 柱状图 line 折线图
            // z: 3, //显不显示点
            showSymbol: false,
            data: this.data,
            //折线样式
            lineStyle: {
              width: 3,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: "rgba(0, 213, 255, 1)" // 0% 处的颜色
                }, {
                  offset: 1, color: "rgba(152, 107, 255, 1)" // 100% 处的颜色
                }]
              },
              shadowBlur: 4,
              shadowColor: "rgba(69,126,247,.2)",
              shadowOffsetY: 4
            },
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: "rgba(0, 213, 255, 0.8)" // 0% 处的颜色
                  }, {
                    offset: 1, color: "rgba(163, 173, 255, 0.1)" // 100% 处的颜色
                  }]
                }
              }
            },
            smooth: true //平滑曲线
          }

        ]

      }
    };
  },
  mounted() {
    this.getData();

  },
  methods: {
    getData(){
      getVulnerableTrend().then(res => {
        this.option.series[0].data = res.map(item => item.num);
        // this.date = res.data.map(item => item.date);
        this.date = [];
        // 遍历原始数据数组
        res.forEach(item => {
          // 提取月和日部分，并格式化为 "MM-DD"
          let formattedDate = item.date.substring(5, 10);
          // 将格式化后的日期字符串添加到新数组中

          this.date.push(formattedDate);
        });
        this.option.xAxis.data = this.date;
        this.getBar();
        console.log(this.option);
      });
      this.getBar();  //获取柱状图
    },
    getBar() {
      //let ec = this.$echarts.init(document.getElementById('box'))
      let ec = this.$echarts.init(this.$refs.box);

      ec.setOption(this.option);
      window.onresize = () => {
        setTimeout(() => {
          const width = this.$refs.box.offsetWidth;
          const height = this.$refs.box.offsetHeight;

          ec.resize({
            width:width,
            height:height
          });
        },500);
        //如果有多个表变动在下方依次写下去就可以了
      };
    }
  }
};


</script>
<style scoped lang="less">
.trend{
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  width: 430px;
  height: 299px;
  border-radius: 10px;
  padding-top: 10px;
  padding-left: 35px;
  box-sizing: border-box;
  h2{
    color: rgba(241, 237, 255, 1);
    font-family: 'YouSheBiaoTiHei';
    margin-bottom: 20px;
    font-size: 24px;
    height: 31px;
    text-align: left;
    text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
  }
}
.box {
  width: 350px;
  height: 215px;
}
</style>
